import Modal from "react-modal";

interface ModalProps {
  isOpen: boolean;
  setOpen: SetBoolean;
  content: JSX.Element;
}

export default function ModalWindow({ isOpen, setOpen, content }: ModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setOpen(false)}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "transparent",
          border: "none",
        },
      }}
    >
      {content}
    </Modal>
  );
}
